import { createEvent, createStore } from "effector";
import { IBuyerDraft } from "../ts";

export const setBuyerDraftData = createEvent<IBuyerDraft>();

export const $buyerDraftData = createStore<IBuyerDraft>({
    companyName: 'ООО “АгроКульт”',
    address: 'Воронежская обл., Воронеж, ул. Победы 67',
    phone: '+7 (',
    email: 'agrocult@gmail.com',
    inn: '1234567899',
    ogrn: '1234567891234',
    country: 'Россия',
});

$buyerDraftData.on(setBuyerDraftData, (_, p) => p);